const enMessages = {
  "Allgemeine Einstellungen": "General Settings",
  "E-Mail-Vorlage": "Email Template",
  "Lizenz": "License",
  "Hilfe & Support": "Help & Support",
  "Wird geladen...": "Loading...",
  "Erneut versuchen": "Try again",
  "Der Server ist nicht erreichbar. Bitte überprüfen Sie Ihre Internetverbindung.": "The server is unreachable. Please check your internet connection.",
  "Einstellungen": "Settings",
  "Zurück": "Back",
  "Sprache": "Language",
  "Deutsch": "German",
  "Englisch": "English",
  "Passwort-Manager": "Password Manager",
  "Sicherheit & Zugriff": "Security & Access",
  "Passwörter": "Passwords",
  "Zugriffsverwaltung": "Access Management",
  "Authentifizierung läuft...": "Authenticating...",
  "Authentifizierung fehlgeschlagen": "Authentication failed",
  "Sitzung ist ungültig oder abgelaufen": "The session is invalid or has expired",
  "Bitte schließen Sie dieses Fenster und versuchen Sie es erneut.": "Please close this window and try again.",
  "Schließen": "Close",
  "Passwort-Manager entsperren": "Unlock Password Manager",
  "Benutzer-Schlüssel": "User key",
  "Passwort eingeben...": "Enter password...",
  "Passwort anzeigen": "Show password",
  "Abbrechen": "Cancel",
  "Entsperren": "Unlock",
  "Entsperren...": "Unlocking...",
  "Passwortdatenbank aktivieren": "Activate password database",
  "Ihre Lizenzinformationen": "Your license information",
  "Lizenz aktivieren": "Activate license",
  "Keine Verbindung zum Server. Bitte überprüfen Sie Ihre Internetverbindung oder versuchen Sie es später erneut.": "No connection to the server. Please check your internet connection or try again later.",
  "Bitte geben Sie Ihren Lizenzschlüssel ein:": "Please enter your license key:",
  "Aktivieren": "Activate",
  "Aktivieren...": "Activating...",
  "Lizenztyp:": "License type:",
  "Lizenzschlüssel:": "License key:",
  "Status:": "Status:",
  "Aktiv": "Active",
  "Inaktiv": "Inactive",
  "Max E-Mails/Tag:": "Max emails/day:",
  "Max E-Mails/Monat:": "Max emails/month:",
  "Lizenz neu aktivieren": "Reactivate license",
  "Noch keine Lizenz? Jetzt anfragen unter": "No license yet? Request one now at",
  "Lädt Einstellungen...": "Loading settings...",
  "Bitte füllen Sie beide Passwortfelder aus.": "Please fill in both password fields.",
  "Die Passwörter stimmen nicht überein.": "The passwords do not match.",
  "Bitte geben Sie das Passwort ein.": "Please enter the password.",
  "Erinnerungen": "Reminders",
  "Immer ans Verschlüsseln erinnern": "Always remind me to encrypt",
  "Sicherheit": "Security",
  "Gespeicherte Passwörter ohne Nachfrage verwenden": "Use saved passwords without asking",
  "E-Mail": "Email",
  "Betreff:": "Subject:",
  "Eine verschlüsselte E-Mail für Sie": "An encrypted email for you",
  "Betreff nicht abändern": "Do not modify the subject",
  "Original-E-Mail in PDF einbetten": "Embed original email in PDF",
  "PDF Anhänge mit Nachfrage direkt verschlüsseln, wenn keine anderen Anhänge vorhanden sind": "Encrypt PDF attachments directly after confirmation when no other attachments are present",
  "Diese Funktion ist nur in der Paid-Lizenz verfügbar.": "This feature is only available with a paid license.",
  "Schutz & Verwaltung": "Protection & Management",
  "Passwort festlegen:": "Set password:",
  "Passwort": "Password",
  "Bestätigung": "Confirmation",
  "Einstellungen sperren": "Lock settings",
  "Passwort eingeben:": "Enter password:",
  "Einstellungen freigeben": "Unlock settings",
  "Einstellungen zurücksetzen:": "Reset settings:",
  "Sind Sie sicher?": "Are you sure?",
  "Alle Einstellungen werden auf die Standardwerte zurückgesetzt. Diese Aktion kann nicht rückgängig gemacht werden.": "All settings will be reset to their default values. This action cannot be undone.",
  "Ja, zurücksetzen": "Yes, reset",
  "Einstellungen zurücksetzen": "Reset settings",
  "Office.js ist nicht verfügbar. Diese Funktion ist nur in Outlook verfügbar.": "Office.js is not available. This feature is only available in Outlook.",
  "Fehler beim Erfassen des E-Mail-Inhalts: {message}": "Error capturing email content: {message}",
  "Unbekannter Fehler": "Unknown error",
  "Der E-Mail-Inhalt ist leer. Bitte geben Sie zuerst einen Text ein.": "The email content is empty. Please enter some text first.",
  "Fehler beim Verarbeiten des E-Mail-Inhalts: {message}": "Error processing email content: {message}",
  "Fehler beim Erfassen der Vorlage: {message}": "Error capturing the template: {message}",
  "Kein E-Mail-Inhalt erfasst.": "No email content captured.",
  "Sie verwenden Ihre selbst erstellte Vorlage": "You are using your custom template",
  "Standard-Vorlage wird verwendet": "The default template is being used",
  "Der erfasste E-Mail-Inhalt wird als Ihre persönliche Vorlage gespeichert und bei verschlüsselten E-Mails verwendet.": "The captured email content will be saved as your personal template and used for encrypted emails.",
  "Erfasse E-Mail-Inhalt...": "Capturing email content...",
  "Als Vorlage übernehmen": "Use as template",
  "Hinweis:": "Note:",
  "Eingebettete Bilder (z. B. Logos) werden aktuell nicht übernommen und beim Versand ignoriert.": "Embedded images (for example logos) are currently not included and will be ignored when sending.",
  "Vorlage speichern?": "Save template?",
  "Der erfasste E-Mail-Inhalt wird als Ihre persönliche Vorlage gespeichert.": "The captured email content will be saved as your personal template.",
  "Ja, speichern": "Yes, save",
  "Vorlage zurücksetzen:": "Reset template:",
  "Die benutzerdefinierte Vorlage wird gelöscht und die Standard-Vorlage wird verwendet.": "The custom template will be deleted and the default template will be used.",
  "Vorlage zurücksetzen": "Reset template",
  "Benutzer-Schlüssel eingeben...": "Enter user key...",
  "Tipp: Gespeicherte Passwörter automatisch vorausfüllen lassen? → Einstellungen öffnen": "Tip: Automatically prefill saved passwords? Open Settings.",
  "Die PDF-Engine ist nicht verfügbar. Bitte laden Sie das Add-in neu.": "The PDF engine is not available. Please reload the add-in.",
  "Die E-Mail wurde erfolgreich gesendet, konnte jedoch nicht zusätzlich unverschlüsselt unter 'Gesendete Elemente' gespeichert werden.": "The email was sent successfully, but could not also be stored unencrypted in Sent Items.",
  "Die E-Mail wurde verschlüsselt und erfolgreich gesendet.": "The email was encrypted and sent successfully.",
  "Die E-Mail wurde erfolgreich gesendet. PDF-Anhänge wurden verschlüsselt.": "The email was sent successfully. PDF attachments were encrypted.",
  "Die E-Mail wurde unverschlüsselt gesendet.": "The email was sent unencrypted.",
  "Die E-Mail wurde erfolgreich gesendet.": "The email was sent successfully.",
  "Die E-Mail wurde für den verschlüsselten Versand vorbereitet.": "The email was prepared for encrypted sending.",
  "Verschlüsselungserinnerung aktivieren?": "Enable encryption reminder?",
  "Soll Avamboo Encrypt Sie beim Senden einer E-Mail an die Verschlüsselung erinnern?": "Should Avamboo Encrypt remind you to encrypt when sending an email?",
  "Sichere E-Mails direkt in Outlook": "Secure emails directly in Outlook",
  "Avamboo Encrypt verschlüsselt Nachrichtentext und Anhänge vor dem Versand, damit vertrauliche Unternehmensdaten geschützt bleiben.": "Avamboo Encrypt encrypts message content and attachments before sending, helping protect confidential business data.",
  "Für wiederkehrende Empfänger können Passwörter optional verschlüsselt gespeichert und beim nächsten Versand schneller verwendet werden.": "For recurring recipients, passwords can optionally be stored encrypted and reused faster the next time you send.",
  "Beim Senden erinnern lassen": "Get reminded when sending",
  "Passwortdatenbank nutzen": "Use the password database",
  "Erinnerung aktivieren": "Enable reminder",
  "Ohne Erinnerung starten": "Start without reminder",
  "Ja, aktivieren": "Yes, enable",
  "Nein, danke": "No, thanks",
  "Stellt Betreff und Text des ursprünglichen Entwurfs wieder her. Anhänge müssen ggf. manuell erneut hinzugefügt werden.": "Restores the original draft subject and body. Attachments may need to be added again manually.",
  "Wird aktiviert...": "Activating...",
  "Wird deaktiviert...": "Deactivating...",
  "Passwortdatenbank deaktivieren": "Deactivate password database",
  "Passwortdatenbank entsperren": "Unlock password database",
  "Passwortdatenbank verwalten": "Manage password database",
  "Verschlüsselung vorbereiten": "Prepare encryption",
  "Verschlüsseln beim Senden": "Encrypt on send",
  "Verschlüsseln beim Senden: AN": "Encrypt on send: ON",
  "Klicken, um die automatische Verschlüsselung beim Senden zu deaktivieren.": "Click to disable automatic encryption when sending.",
  "Aktiviert die automatische Verschlüsselung beim Senden einer E-Mail.": "Enables automatic encryption when sending an email.",
  "Bereitet die E-Mail für den verschlüsselten Versand vor. Der Entwurf wird transformiert – beim Senden gibt es keine Verzögerung.": "Prepares the email for encrypted sending. The draft is transformed, so there is no delay when sending.",
  "Bitte geben Sie das Passwort ein. Die E-Mail wird im Entwurf vorbereitet und kann danach normal gesendet werden.": "Please enter the password. The email will be prepared in the draft and can then be sent normally.",
  "Bitte fügen Sie mindestens einen Empfänger hinzu.": "Please add at least one recipient.",
  "Empfänger": "Recipients",
  "Keine Empfänger": "No recipients",
  "Gespeicherte Empfänger / Passwörter": "Saved recipients / passwords",
  "– Bitte wählen –": "– Please select –",
  "Wenn Sie Ihren Benutzer-Schlüssel eingeben, können Passwörter aus dem Passwortmanager automatisch angewendet werden.": "If you enter your user key, passwords from the password manager can be applied automatically.",
  "Bestehendes Passwort für diese Empfänger gefunden und vorausgefüllt.": "An existing password was found for these recipients and prefilled.",
  "Für diese Empfänger wurde ein gespeichertes Passwort gefunden. Bitte wählen Sie es aus der Liste aus.": "A saved password was found for these recipients. Please select it from the list.",
  "Bitte geben Sie ein Passwort ein.": "Please enter a password.",
  "Wiederholung": "Repeat password",
  "Passwort wiederholen...": "Repeat password...",
  "Kennwort anzeigen": "Show password",
  "Betreff nicht verschlüsseln": "Do not encrypt the subject",
  "Nur PDF-Anhänge verschlüsseln (vorbereiten)": "Encrypt PDF attachments only (prepare)",
  "Wird vorbereitet...": "Preparing...",
  "Wird zurückgesetzt…": "Restoring...",
  "Verschlüsselung rückgängig machen": "Undo encryption",
  "Bitte geben Sie zuerst ein Passwort und die Wiederholung ein.": "Please enter the password and confirmation first.",
  "ca. {seconds} Sekunden": "approx. {seconds} seconds",
  "ca. {minutes} Minute": "approx. {minutes} minute",
  "ca. {minutes} Minuten": "approx. {minutes} minutes",
  "New Outlook für Mac": "New Outlook for Mac",
  "Unbekannt": "Unknown",
  "Outlook Web": "Outlook Web",
  "New Outlook (Desktop)": "New Outlook (Desktop)",
  "Avamboo Encrypt – Supportanfrage": "Avamboo Encrypt – Support request",
  "Benutzer E-Mail-Adresse": "User email address",
  "PDF-Handbuch öffnen": "Open PDF manual",
  "Support kontaktieren": "Contact support",
  "Bei Problemen oder Fragen wenden Sie sich bitte direkt an den Avamboo Support.": "If you have any problems or questions, please contact Avamboo support directly.",
  "Umgebung:": "Environment:",
  "Zeitpunkt:": "Timestamp:",
  "Version:": "Version:",
  "Version (Frontend): {version}": "Version (frontend): {version}",
  "Version (Backend):  {version}": "Version (backend):  {version}",
  "Umgebung: {environment}": "Environment: {environment}",
  "Zeitpunkt: {timestamp}": "Timestamp: {timestamp}",
  "Lizenz: {license}": "License: {license}",
  "Benutzer E-Mail-Adresse: {email}": "User email address: {email}",
  "Bitte beschreiben Sie Ihr Anliegen hier:": "Please describe your issue here:",
  "(Tipp: Eine kurze Beschreibung und ein Screenshot helfen uns,\ndas Problem schneller zu verstehen und zu lösen.)": "(Tip: A short description and a screenshot help us understand and solve the issue faster.)",
  "Passwörter verwalten": "Manage passwords",
  "Fehler beim Löschen des Passworts": "Error deleting the password",
  "Passwortdatenbank wurde erfolgreich gelöscht.": "The password database was deleted successfully.",
  "Fehler beim Löschen der Passwortdatenbank": "Error deleting the password database",
  "Ihr Zugriff wurde erfolgreich beendet.": "Your access was ended successfully.",
  "Fehler beim Beenden des Zugriffs": "Error ending access",
  "Passwörter ausblenden": "Hide passwords",
  "Passwörter anzeigen": "Show passwords",
  "Seite wird in Kürze aktualisiert...": "The page will refresh shortly...",
  "Bitte warten, Daten werden aktualisiert...": "Please wait, data is being refreshed...",
  "Keine aktive Passwortdatenbank vorhanden.": "No active password database available.",
  "Was möchten Sie tun?": "What would you like to do?",
  "Wird erstellt...": "Creating...",
  "Eigene Passwortdatenbank erstellen": "Create own password database",
  "Access Code eingeben": "Enter access code",
  "Sie nutzen derzeit den Free-Plan.": "You are currently using the free plan.",
  "Um den Passwort-Manager zu verwenden, können Sie eine eigene Passwortdatenbank erstellen.": "To use the password manager, you can create your own password database.",
  "Öffnet den Passwort-Manager, wo Sie einen Benutzer-Schlüssel festlegen und die Passwortdatenbank aktivieren können. Ihre Passwörter werden verschlüsselt gespeichert.": "Opens the password manager, where you can set a user key and activate the password database. Your passwords are stored encrypted.",
  "Benutzer-Schlüssel eingeben, um gespeicherte Passwörter zu verwenden oder neue Einträge zu speichern.": "Enter your user key to use saved passwords or store new entries.",
  "Öffnet ein separates Fenster zur Verwaltung Ihrer Passwortdatenbank (Anzeigen, Bearbeiten, Entschlüsseln).": "Opens a separate window to manage your password database (view, edit, decrypt).",
  "Deaktiviert den Passwortmanager vorübergehend. Ihre Daten bleiben vollständig erhalten.": "Temporarily disables the password manager. Your data remains fully intact.",
  "Geben Sie Ihren Benutzer-Schlüssel ein, um die Passwortdatenbank zu entsperren.": "Enter your user key to unlock the password database.",
  "Wird entsperrt...": "Unlocking...",
  "Lade Passwörter...": "Loading passwords...",
  "E-Mail suchen...": "Search email...",
  "Keine Datensätze zum Anzeigen": "No records to display",
  "Hinzufügen": "Add",
  "Bearbeiten": "Edit",
  "Löschen": "Delete",
  "Speichern": "Save",
  "Ziehen Sie eine Spaltenüberschrift hierher, um zu gruppieren": "Drag a column header here to group by that column",
  "Gruppierung aufheben": "Ungroup",
  "{0} von {1} Seiten": "{0} of {1} pages",
  "({0} Einträge)": "({0} items)",
  "Erste Seite": "First page",
  "Letzte Seite": "Last page",
  "Nächste Seite": "Next page",
  "Vorherige Seite": "Previous page",
  "Nächste Pager-Elemente": "Next pager items",
  "Vorherige Pager-Elemente": "Previous pager items",
  "Einträge pro Seite": "Items per page",
  "Einträge": "Items",
  "Seite": "Page",
  "von": "of",
  "Seiten": "pages",
  "Schlüssel konnte nicht erstellt werden. Bitte entsperren Sie erneut.": "The key could not be created. Please unlock again.",
  "Eigene Passwortdatenbank erfolgreich erstellt.": "Your own password database was created successfully.",
  "Fehler beim Erstellen der Datenbank": "Error creating the database",
  "Fehler beim Erstellen der Passwortdatenbank": "Error creating the password database",
  "Fehler beim Laden der Passwörter": "Error loading passwords",
  "Email und Passwort dürfen nicht leer sein": "Email and password must not be empty.",
  "Fehler beim Speichern des Passworts": "Error saving the password",
  "Das Teilen von Passwortdatenbanken ist Teil des Paid-Plans.": "Sharing password databases is part of the paid plan.",
  "Bitte entsperren Sie zuerst die Passwortdatenbank auf der Sicherheitsseite.": "Please unlock the password database on the security page first.",
  "Nur Sie haben aktuell Zugriff auf diese Passwortdatenbank.": "Only you currently have access to this password database.",
  "Benutzer haben aktuell Zugriff auf diese Passwortdatenbank.": "users currently have access to this password database.",
  "Anzeigen": "View",
  "➕ E-Mail hinzufügen": "➕ Add email",
  "🗑️ Passwortdatenbank löschen": "🗑️ Delete password database",
  "🚪 Zugriff beenden": "🚪 End access",
  "Erstellt am": "Created on",
  "Aktionen": "Actions",
  "Passwortdatenbank löschen": "Delete password database",
  "Möchten Sie diese Passwortdatenbank wirklich löschen?": "Do you really want to delete this password database?",
  "Nach diesem Vorgang verlieren alle Benutzer den Zugriff auf diese Passwortdatenbank.": "After this action, all users will lose access to this password database.",
  "Ja, löschen": "Yes, delete",
  "Zugriff beenden": "End access",
  "Möchten Sie Ihren Zugriff auf diese geteilte Passwortdatenbank wirklich beenden?": "Do you really want to end your access to this shared password database?",
  "Sie können die Passwörter danach nicht mehr einsehen oder bearbeiten.": "Afterwards, you will no longer be able to view or edit the passwords.",
  "Um erneut Zugriff zu erhalten, benötigen Sie einen neuen Access Code vom Owner.": "To regain access, you will need a new access code from the owner.",
  "Ja, Zugriff beenden": "Yes, end access",
  "Fehler beim Laden des Status": "Error loading the status",
  "Fehler beim Laden des Sicherheitsstatus": "Error loading the security status",
  "Bitte geben Sie Ihre E-Mail-Adresse ein": "Please enter your email address.",
  "Bitte füllen Sie alle Felder aus": "Please fill in all fields.",
  "Passwörter stimmen nicht überein": "Passwords do not match.",
  "Benutzer-Schlüssel muss mindestens 8 Zeichen lang sein": "The user key must be at least 8 characters long.",
  "Bitte bestätigen Sie, dass Sie die Warnung verstanden haben": "Please confirm that you understood the warning.",
  "Fehler beim Einrichten des Schlüssels": "Error setting up the key",
  "Fehler beim Aktivieren der Passwortdatenbank": "Error activating the password database",
  "Fehler bei der Schlüsselgenerierung. Bitte versuchen Sie es erneut.": "Error generating the key. Please try again.",
  "Fehler bei der Verschlüsselung. Bitte versuchen Sie es erneut.": "Encryption error. Please try again.",
  "Fehler beim Einrichten des Benutzer-Schlüssels": "Error setting up the user key",
  "Bitte geben Sie Ihr Passwort ein": "Please enter your password.",
  "Falsches Passwort. Bitte versuchen Sie es erneut.": "Incorrect password. Please try again.",
  "Zeitüberschreitung beim Entsperren. Bitte versuchen Sie es erneut.": "Unlock timed out. Please try again.",
  "Fehler beim Entsperren der Datenbank": "Error unlocking the database",
  "Neue Benutzer-Schlüssel stimmen nicht überein": "The new user keys do not match.",
  "Neuer Benutzer-Schlüssel muss mindestens 8 Zeichen lang sein": "The new user key must be at least 8 characters long.",
  "Fehler beim Laden der Schlüssel": "Error loading the keys",
  "Fehler beim Ändern des Benutzer-Schlüssels": "Error changing the user key",
  "Alter Benutzer-Schlüssel ist falsch": "The old user key is incorrect.",
  "Fehler beim Laden der Benutzer": "Error loading the users",
  "Fehler beim Ändern des MasterKeys": "Error changing the master key",
  "Fehler beim Ändern des MasterKeys: {message}": "Error changing the master key: {message}",
  "Fehler beim Zurücksetzen des Passwort-Managers": "Error resetting the password manager",
  "Bitte geben Sie eine E-Mail-Adresse ein": "Please enter an email address.",
  "Fehler beim Aktualisieren der E-Mail": "Error updating the email",
  "Fehler beim Aktualisieren der E-Mail-Adresse": "Error updating the email address",
  "Laden...": "Loading...",
  "Passwortdatenbank reaktivieren": "Reactivate password database",
  "Der Passwort-Manager ist derzeit deaktiviert. Entsperren Sie Ihren Benutzer-Schlüssel, um ihn zu reaktivieren.": "The password manager is currently deactivated. Unlock your user key to reactivate it.",
  "Geben Sie Ihren Benutzer-Schlüssel ein, um die Passwortdatenbank zu reaktivieren.": "Enter your user key to reactivate the password database.",
  "Ihr Passwort": "Your password",
  "Entsperren und reaktivieren": "Unlock and reactivate",
  "Die Entschlüsselung erfolgt client-seitig. Ihr Passwort wird niemals an den Server gesendet.": "Decryption happens on the client side. Your password is never sent to the server.",
  "Aktueller Benutzer-Schlüssel": "Current user key",
  "Als gelesen markieren": "Mark as read",
  "Alter Benutzer-Schlüssel": "Old user key",
  "Benutzer-Schlüssel ändern": "Change user key",
  "Benutzer-Schlüssel festlegen": "Set user key",
  "Fehler beim Laden der Zugriffe": "Error loading accesses",
  "Fehler beim Laden der Zugriffsdaten": "Error loading access data",
  "Der Passwort-Manager ist derzeit deaktiviert. Legen Sie einen Benutzer-Schlüssel fest, um ihn zu aktivieren.": "The password manager is currently deactivated. Set a user key to activate it.",
  "Legen Sie einen sicheren Benutzer-Schlüssel fest. Dieser wird verwendet, um Ihre privaten Schlüssel zu verschlüsseln.": "Set a secure user key. It is used to encrypt your private keys.",
  "Geben Sie Ihren Benutzer-Schlüssel ein, um auf Ihre verschlüsselten Passwörter zuzugreifen.": "Enter your user key to access your encrypted passwords.",
  "Geteilte Passwortdatenbank": "Shared password database",
  "Ihr Benutzer-Schlüssel": "Your user key",
  "E-Mail-Adresse": "Email address",
  "ihre.email@beispiel.de": "your.email@example.com",
  "Bitte überprüfen Sie Ihre E-Mail-Adresse. Diese wird für die Zugriffsverwaltung verwendet.": "Please verify your email address. It will be used for access management.",
  "Mindestens 8 Zeichen": "At least 8 characters",
  "Passwort wiederholen": "Repeat password",
  "Wichtiger Hinweis": "Important note",
  "Ihr Benutzer-Schlüssel kann nicht wiederhergestellt werden. Wenn Sie ihn vergessen, verlieren Sie den Zugriff auf Ihre verschlüsselten Daten.": "Your user key cannot be recovered. If you forget it, you will lose access to your encrypted data.",
  "Ich habe verstanden und akzeptiere das Risiko": "I understand and accept the risk.",
  "Wird eingerichtet...": "Setting up...",
  "Hinweis: Die Verschlüsselung erfolgt client-seitig. Ihr Benutzer-Schlüssel wird niemals an den Server gesendet.": "Note: Encryption happens on the client side. Your user key is never sent to the server.",
  "Benutzer-Schlüssel erfolgreich geändert!": "User key changed successfully!",
  "Ihr neues Passwort wird ab jetzt für das Entsperren verwendet.": "Your new password will be used for unlocking from now on.",
  "Wichtige Benachrichtigungen ({count})": "Important notifications ({count})",
  "Bitte prüfen, bevor Sie fortfahren.": "Please review them before continuing.",
  "Alle als gelesen markieren": "Mark all as read",
  "Weiter zu Passwörter": "Continue to passwords",
  "Konto": "Account",
  "Meine Passwortdatenbank": "My password database",
  "Neuen Benutzer-Schlüssel bestätigen": "Confirm new user key",
  "Neuen Benutzer-Schlüssel wiederholen": "Repeat new user key",
  "Neuer Benutzer-Schlüssel": "New user key",
  "Wird geändert...": "Updating...",
  "Wird zurückgesetzt...": "Resetting...",
  "Ändern Sie Ihren Benutzer-Schlüssel. Der Private Key wird mit dem neuen Benutzer-Schlüssel verschlüsselt.": "Change your user key. The private key will be encrypted with the new user key.",
  "E-Mail-Adresse erfolgreich aktualisiert.": "Email address updated successfully.",
  "Nicht gesetzt": "Not set",
  "E-Mail-Adresse ändern": "Change email address",
  "Speichern...": "Saving...",
  "Gefahrenbereich": "Danger zone",
  "MasterKey wurde erfolgreich geändert.": "Master key was changed successfully.",
  "Passwort-Manager zurücksetzen": "Reset password manager",
  "Setzt den Passwort-Manager vollständig zurück und entfernt Schlüssel sowie Zugriffe. Anschließend müssen Sie ihn neu einrichten.": "Fully resets the password manager and removes keys as well as accesses. You will need to set it up again afterwards.",
  "Zurücksetzen": "Reset",
  "MasterKey ändern": "Change master key",
  "Verschlüsselt alle Einträge neu mit einem neuen MasterKey.": "Re-encrypts all entries with a new master key.",
  "Benutzer-Schlüssel vergessen?": "Forgot your user key?",
  "Wenn Sie Ihren Benutzer-Schlüssel nicht mehr kennen, können Sie den Passwort-Manager zurücksetzen und neu einrichten.": "If you no longer know your user key, you can reset the password manager and set it up again.",
  "Diese Aktion kann nicht rückgängig gemacht werden!": "This action cannot be undone!",
  "Dabei werden alle kryptografischen Schlüssel zurückgesetzt.": "All cryptographic keys will be reset.",
  "Alle bestehenden Passwortdatenbanken und Zugriffe können danach nicht mehr genutzt werden.": "All existing password databases and accesses can no longer be used afterwards.",
  "MasterKey ändern?": "Change master key?",
  "Dieser Vorgang kann nicht rückgängig gemacht werden!": "This operation cannot be undone!",
  "Alle Einträge werden neu verschlüsselt.": "All entries will be re-encrypted.",
  "Ja, MasterKey ändern": "Yes, change master key",
  "Verwenden Sie das Menü links, um zu den Passwörtern oder zur Zugriffsverwaltung zu navigieren.": "Use the menu on the left to navigate to passwords or access management.",
  "Aktive Datenbank gewechselt": "Active database switched",
  "Fehler beim Wechseln": "Error switching",
  "Fehler beim Wechseln der Datenbank": "Error switching the database",
  "Aktive Datenbank festgelegt": "Active database set",
  "Fehler beim Festlegen": "Error setting",
  "Fehler beim Festlegen der aktiven Datenbank": "Error setting the active database",
  "Bitte geben Sie einen Access Code ein": "Please enter an access code.",
  "Anfrage gesendet. Bitte warten Sie auf Freigabe durch den Besitzer.": "Request sent. Please wait for approval from the owner.",
  "Fehler beim Einlösen des Access Codes": "Error redeeming the access code",
  "Gültig": "Valid",
  "Access Code erstellt. Der Access Code wird nur jetzt angezeigt – bitte kopieren Sie ihn.": "Access code created. It is shown only now, so please copy it.",
  "Fehler beim Erstellen des Access Codes": "Error creating the access code",
  "Kopieren fehlgeschlagen": "Copy failed",
  "Access Code widerrufen": "Revoke access code",
  "Fehler beim Widerrufen des Access Codes": "Error revoking the access code",
  "Zugriff erfolgreich entzogen.": "Access revoked successfully.",
  "Fehler beim Entziehen des Zugriffs": "Error revoking access",
  "MasterKey nicht verfügbar. Bitte entsperren Sie zuerst die Datenbank.": "Master key not available. Please unlock the database first.",
  "Zugriff freigegeben": "Access granted",
  "Fehler beim Freigeben": "Error granting access",
  "Fehler beim Freigeben des Zugriffs": "Error granting access",
  "Zugriff abgelehnt": "Access rejected",
  "Fehler beim Ablehnen": "Error rejecting",
  "Fehler beim Ablehnen des Zugriffs": "Error rejecting access",
  "Alias gespeichert": "Alias saved",
  "Alias entfernt": "Alias removed",
  "Fehler beim Speichern des Alias": "Error saving the alias",
  "Das Teilen von Passwortdatenbanken ist Teil des Paid-Plans. Bitte aktivieren Sie eine Paid-Lizenz, um diese Funktion zu nutzen.": "Sharing password databases is part of the paid plan. Please activate a paid license to use this feature.",
  "Lade Zugriffsdaten...": "Loading access data...",
  "Aktive Passwortdatenbank": "Active password database",
  "Zu meiner Passwortdatenbank wechseln": "Switch to my password database",
  "Erstellt eine persönliche Passwortdatenbank und aktiviert sie direkt.": "Creates a personal password database and activates it immediately.",
  "Alias vergeben": "Set alias",
  "Keine aktive Passwortdatenbank ausgewählt.": "No active password database selected.",
  "Einer Datenbank beitreten": "Join a database",
  "Access Code": "Access code",
  "Alias-Name (optional, nur für mich)": "Alias name (optional, only for me)",
  "z.B. Team-Passwörter": "e.g. Team passwords",
  "Wird gesendet...": "Sending...",
  "Anfragen": "Request access",
  "Meine Zugriffe": "My accesses",
  "Keine Zugriffe vorhanden.": "No accesses available.",
  "Datenbank": "Database",
  "Zugriff": "Access",
  "Benutzer mit Zugriff": "Users with access",
  "Keine weiteren Benutzer.": "No additional users.",
  "Benutzer (E-Mail)": "User (email)",
  "Rolle": "Role",
  "Aktion": "Action",
  "Besitzer": "Owner",
  "Zugriff entziehen": "Revoke access",
  "Meine Datenbank teilen": "Share my database",
  "Access Code erstellen": "Create access code",
  "Erstellte Access Codes": "Created access codes",
  "Code": "Code",
  "Gültig bis": "Valid until",
  "Kopiert!": "Copied!",
  "Kopieren": "Copy",
  "Hinweis: Access Codes sind standardmäßig 72 Stunden gültig und werden nur in dieser Sitzung im Klartext angezeigt.": "Note: Access codes are valid for 72 hours by default and are shown in plain text only in this session.",
  "Meine Access Codes": "My access codes",
  "Auch inaktive Access Codes anzeigen": "Show inactive access codes too",
  "Lade Access Codes...": "Loading access codes...",
  "Keine Access Codes vorhanden.": "No access codes available.",
  "Keine gültigen Access Codes vorhanden.": "No valid access codes available.",
  "Status": "Status",
  "Verwendet am": "Used on",
  "Entziehen": "Revoke",
  "Anfragen an meine Datenbank": "Requests to my database",
  "Keine ausstehenden Anfragen.": "No pending requests.",
  "Freigeben": "Approve",
  "Anzeigename (nur für Sie sichtbar)": "Display name (visible only to you)",
  "z.B. Team-Tresor": "e.g. Team vault",
  "Leer lassen zum Entfernen des Alias.": "Leave empty to remove the alias.",
  "Die Verschlüsselung konnte nicht vorbereitet werden. Bitte versuchen Sie es erneut.": "Encryption could not be prepared. Please try again.",
  "Diese E-Mail wurde mit <strong>Avamboo Encrypt</strong> verschlüsselt.": "This email was encrypted with <strong>Avamboo Encrypt</strong>.",
  "Bitte öffnen Sie den Anhang mit dem Adobe Acrobat Reader und geben Sie das vereinbarte Passwort ein.": "Please open the attachment with Adobe Acrobat Reader and enter the agreed password.",
  "Zu viele Anhänge. Maximal {count} Anhänge sind erlaubt.": "Too many attachments. A maximum of {count} attachments is allowed.",
  "Die Anhänge sind zu groß ({totalMB} MB). Das Maximum beträgt 5 MB.": "The attachments are too large ({totalMB} MB). The maximum is 5 MB.",
  "Die Datei {name} kann vom Empfänger möglicherweise nicht geöffnet werden.\nDer Adobe Acrobat unterstützt das Öffnen von Dateien mit der Endung {ext} nicht.\nMöchten Sie fortfahren?": "The recipient may not be able to open the file {name}.\nAdobe Acrobat does not support opening files with the extension {ext}.\nDo you want to continue?",
  "Die Original-E-Mail konnte nicht eingebettet werden. Die Verschlüsselung wird ohne EML-Anhang fortgesetzt.": "The original email could not be embedded. Encryption will continue without the EML attachment.",
  "Die PDF-Engine ist abgestürzt. Bitte laden Sie das Add-in neu und versuchen Sie es erneut.": "The PDF engine crashed. Please reload the add-in and try again.",
  "Verschlüsselte E-Mail": "Encrypted email",
  "Verschluesselte-Mail.pdf": "Encrypted-Mail.pdf",
  "Zu viele PDF-Anhänge ({current}). Maximal {max} PDF-Anhänge sind erlaubt.": "Too many PDF attachments ({current}). A maximum of {max} PDF attachments is allowed.",
  "Die PDF-Anhänge sind zu groß ({totalMB} MB). Das Maximum beträgt 25 MB.": "The PDF attachments are too large ({totalMB} MB). The maximum is 25 MB.",
  "Fehler beim Verschlüsseln\n\nDie PDF-Datei \"{name}\" konnte nicht verschlüsselt werden.": "Error during encryption\n\nThe PDF file \"{name}\" could not be encrypted.",
  "Ein PDF-Anhang dieser E-Mail ist bereits passwortgeschützt und wird nicht erneut verschlüsselt.": "One PDF attachment in this email is already password-protected and will not be encrypted again.",
  "{count} PDF-Anhänge dieser E-Mail sind bereits passwortgeschützt und werden nicht erneut verschlüsselt.": "{count} PDF attachments in this email are already password-protected and will not be encrypted again.",
  "Betreff und Text wurden wiederhergestellt. Die folgenden Anhänge müssen manuell erneut hinzugefügt werden: {names}": "Subject and body were restored. The following attachments must be added again manually: {names}",
  "Als aktive DB festlegen": "Set as active DB",
  "Wartet auf Freigabe": "Waiting for approval",
  "Freigegeben": "Approved",
  "Ausstehend": "Pending",
  "Entzogen": "Revoked",
  "Verwendet": "Used",
  "Abgelaufen": "Expired",
};

export default enMessages;
